
<template>


    <div class="FileUpload" v-show="Visible" :class="{Image:FileType=='Image',Document:FileType!='Image'}">


        <div style="overflow:hidden" v-show="(this.FilePath_Picture != null && this.FilePath_Picture != '') || (this.FilePath_Progress != null) ">
            <table border="0" cellspacing="0" cellpadding="0" width="100%">
                <tr>
                    <td style="vertical-align:bottom;position:relative">
                        <t-img :src="FilePath_Picture"
                             style="max-width:150px" runat="server"
                             class="PreviewImage" />

                        <div class="UploadProgress"
                             v-html="FilePath_Progress">
                        </div>

                        <a v-show="FilePath != null && FilePath != ''" 
                           
                           :href="$util.PrefixUrl(FilePath)" target="_blank" style="color:black">下載</a>
                    </td>
                </tr>
            </table>
        </div>

        <table border="0">
            <tr>
                <td>
                    <input type="text" runat="server" :nullable="Nullable" :Disabled="Disabled" style="width:280px" v-model="FilePath" /> 
                </td>
                <td>
                    <div style="width:80px;">
                        <nobr>
                            <span style="width:80px" class="SingleFileuploadButton">瀏覽</span>
                            <input type="file"
                                   watermark=""
                                   auto_rename="false"
                                   image_only="true"
                                   :Disabled="Disabled"
                                   style="width:80px;opacity:0;filter:alpha(opacity=0);position:relative;left:-80px"
                                   @change="OnSingleFileSelect"
                                   runat="server" />


                        </nobr>
                    </div>
                </td>
            </tr>
           
        </table>

    </div>

</template>

<script>
    import Utility from '@/Common/Utility'
    import UploadManager from '@/Common/UploadManager'

    export default {
        data() {
            return {

                FilePath: "",
                FilePath_Progress: "",
                FilePath_Picture: "",
                TaskId: -1,
                SourceFileName: "",
                isPreparePreviewImageRunning: false,
                FileType: "Document",
                m_LastTriggerChangeTime : Date.parse("1990/01/01"),
                m_LastValueSetTime: Date.parse("1990/01/01"),
                m_Attribute: {
                    Nullable: false,
                    Enabled: true
                }
            }
        }
        ,

        //Only TargetFolderPath
        props: ["value", "nullable", "Attribute", "TargetFolderPath"],


        computed: {

            CssClass: {

                get: function () {
                    let result = "";


                    if (this.Attribute != null && this.Attribute.CssClass != null) {
                        result = this.Attribute.CssClass;
                    }

                    return result;
                }
            }
            ,
            Nullable: function () {
                if (this.m_Attribute.Nullable == null) {
                    this.m_Attribute.Nullable = false;
                }

                return this.m_Attribute.Nullable + "";
            }
            ,

            IsImageFile: function () {
                let isImageFile = true;

                if (this.FilePath != "" && this.FilePath != null) {
                    isImageFile = Utility.IsImageFile(this.FilePath);
                }

                return isImageFile;
            },


            ReadOnly: {

                get: function () {
                    let result = false;

                    if (this.m_Attribute != null && this.m_Attribute.ReadOnly != null) {
                        result = this.Attribute.ReadOnly;
                    }

                    return result;
                },
                set: function (val) {
                    alert("set val=" + val);
                }

            }
            ,
            Disabled: {

                get: function () {
                    let result = false;

                    if (this.m_Attribute.Enabled != null) {
                        result = !this.m_Attribute.Enabled;
                    }

                    return result;
                },
                set: function (val) {
                    alert("set val=" + val);
                }

            },

            Visible: {

                get: function () {
                    let result = true;


                    if (this.m_Attribute.Visible != null) {
                        result = this.m_Attribute.Visible;
                    }

                    return result;
                }


            }

        }
        ,

        methods: {

            OnSingleFileSelect(e) {
                let fileElement;
                var uploadButtonElement;
                let pictureElementId, pictureElement;
                var uploadElement;
                var imgElementId;
                var imgElement;
                var task;
                var watermark = "";
                var imageOnly = false;
                //var uploadPageUrl = Utility.GetBaseUrl() + "/Util/Upload.aspx"
                var uploadPageUrl = Utility.GetBaseUrl() + "/File/Upload"
                var _uploadPageUrl = "";
                var i;

                 

                fileElement = e.target;

                if (fileElement.files.length == 0) {
                    return;
                }


                this.SourceFileName = fileElement.files[0].name;

                if (Utility.IsImageFile(this.SourceFileName)) {
                    this.FileType = "Image";
                }
                else {
                    this.FileType = "Document";
                }

                UploadManager.Suspend();
                UploadManager.RemoveAllTasks();

                if (typeof (fileElement.files) != "undefined") {
                    watermark = fileElement.getAttribute("watermar");

                    if (fileElement.getAttribute("image_only") == "true") {
                        imageOnly = true;
                    }

                    if (watermark == null) {
                        if (typeof (GetWatermark) != "undefined") {
                            watermark = GetWatermark();
                        }
                    }

                    _uploadPageUrl = uploadPageUrl;
                     
                    task = UploadManager.CreateTask(fileElement.files[0], _uploadPageUrl);

                    if (this.TargetFolderPath != null) {
                        task.TargetFolderPath = this.TargetFolderPath;
                    }

                    this.TaskId = task.Id;
                }
                else {
                    return;
                }

                task.Watermark = watermark;

                if (fileElement.getAttribute("auto_rename") == "true") {
                    task.AutoRename = true;
                }
                else {
                    task.AutoRename = false;
                }


                if (fileElement.getAttribute("move_to_cache") == "true") {
                    task.MoveToCache = "true";
                }
                else {
                    task.MoveToCache = "false";
                }

                UploadManager.TaskProgressChange = this.OnSingleFileUploadTaskProgressChange;
                UploadManager.TaskSuccess = this.OnSingleFileUploadTaskSuccess;
                UploadManager.TaskFail = function (taskId, responseText) {
                    this.OnSingleFileUploadTaskFail(taskId, responseText);
                }.bind(this);

                uploadButtonElement = fileElement.parentElement.children[0];

                task.UploadElementId = uploadButtonElement.id.replace(/_Label$/, "");
                uploadElement = document.getElementById(task.UploadElementId);


                pictureElementId = task.UploadElementId + "_Picture";
                pictureElement = document.getElementById(pictureElementId);
                if (pictureElement != null) {
                    pictureElement.setAttribute("NeedPreview", "true");
                    pictureElement.style.display = "";
                }

                fileElement.value = "";

                UploadManager.Resume();

                UploadManager.ExecuteUploadTasks();

                setTimeout(
                    function () {
                        this.PrepareSingleFileUploadImagePreview();
                    }.bind(this)
                    ,
                    100
                );
            },



            OnSingleFileUploadTaskProgressChange(taskId, progress) {
                this.ShowSingleFileUploadProgress(taskId, progress)
            },



            OnSingleFileUploadTaskSuccess(taskId, responseText) {
                let task;
                let responseObj;


                task = UploadManager.GetTask(taskId);
                this.FilePath_Progress = "100%";

                responseObj = JSON.parse(task.XmlHttp.responseText);
                this.UpdateElementByValue(responseObj.FilePath);

                setTimeout(
                    function () {
                        this.$emit("completed", responseObj.FilePath);
                    }.bind(this),
                    100
                );
            },



            OnSingleFileUploadTaskFail(taskId, responseText) {
                var divElement;

                this.ShowSingleFileUploadFail(taskId, responseText);
            },


            ShowSingleFileUploadProgress(taskId, progress) {
                var progressElementId;
                var progressElement;
                var task;


                task = UploadManager.GetTask(taskId);


                if (progress >= 98) {
                    this.FilePath_Progress = "98%";
                }
                else {
                    this.FilePath_Progress = progress + "%";
                }
            },



            ShowSingleFileUploadFail(taskId, responseText) {
                let task;
                let windowObj;


                task = UploadManager.GetTask(taskId);

                this.FilePath_Progress = "<FONT COLOR=RED>Fail</FONT>";


                if (responseText != "" && responseText != null) {
                    windowObj = window.open("about:blank", "_blank");
                    windowObj.document.write(responseText);
                }
            },


            PrepareSingleFileUploadImagePreview() {
                if (this.isPreparePreviewImageRunning) {
                    return;
                }
                else {
                    this.PrepareSingleFileUploadImagePreviewImpl();
                }
            },

            PrepareSingleFileUploadImagePreviewImpl() {
                let task;
                var i;

 
                if (Utility.IsImageFile(this.SourceFileName)) {

                    this.isPreparePreviewImageRunning = true;

                    for (i = 0; i < UploadManager.Tasks.length; i++) {
                        task = UploadManager.Tasks[i];
                        if (task.Id == this.TaskId) {
                            this.FilePath_Picture = task.TempFileName;
                        }
                    }//end for (i = 0; i < UploadManager.Tasks.length; i++) {
 

                    if (UploadManager.GetRunningTaskCount() > 0) {
                        setTimeout(
                            function () {
                                this.PrepareSingleFileUploadImagePreviewImpl();
                            }.bind(this)
                            ,
                            1000
                        );
                    }
                    else {
                        this.isPreparePreviewImageRunning = false;
                    }
                }
            },


            OnValueChange(e) {
                this.$emit("input", e.target.value);
                this.$emit("change", e.target.value);
            },

            UpdateElementByValue(value) {
                this.FilePath = value;


                if (value == "") {
                    this.FilePath_Progress = "";
                }

                if (
                    this.FilePath != null &&
                    Utility.IsImageFile(this.FilePath)
                ) {
                    this.FilePath_Picture = this.FilePath;
                    this.FileType = "Image";
                }
                else {
                    this.FilePath_Picture = null;
                    this.FileType = "Document";
                }
            },

            UpdateElementByAttribute() {

            },


        },

        created() {


            if (this.value != null) {
                this.UpdateElementByValue(this.value);
            }


            if (this.nullable == "false") {
                this.m_Attribute.Nullable = false;
            }
            else {
                this.m_Attribute.Nullable = true;
            }

            if (this.Attribute != null) {
                Utility.SetNotNullAttributes(this.m_Attribute, this.Attribute);
            }
        },

        watch: {

            value: function (newVal, oldVal) {

                if (newVal != this.FilePath) {
                    this.FilePath_Progress = "";
                    this.UpdateElementByValue(newVal);
                    this.m_LastValueSetTime = new Date();
                }
            },

            FilePath: function (newVal, oldVal) {

                if ((new Date()) - this.m_LastValueSetTime > 500) {
                    this.$emit("input", this.FilePath);
                    this.$emit("change", this.FilePath);
                    this.m_LastTriggerChangeTime = new Date();
                }
            },

            Attribute: function (newVal, oldVal) {
                Utility.SetNotNullAttributes(this, this.m_Attribute, newVal);
            },

            nullable: function (newVal, oldVal) {

            }
        }


    }
</script>

<style>
    .FileUpload.Document > div {
        width: 100%;
    }

    .FileUpload.Document .PreviewImage {
        display: none;
    }

    .FileUpload.Image > div {
        width: 150%;
    }

    .UploadProgress {
        background-color: rgba(210, 285, 185, 0.8);
        font-weight: bold;
        color: Black;
        height: 20px;
        position: absolute;
        bottom: 0px;
        left: 0px;
        border: none;
        text-align: center;
        z-index: 10;
    }

    .FileUpload.Image .UploadProgress {
        width: 150px;
    }


    .FileUpload.Document .UploadProgress {
        width: 283px;
        position: static;
    }

    .UploadProgress:empty {
        display: none;
    }

    .SingleFileuploadButton {
        border: 1px solid gray;
        background-color: rgb(248,248,248);
        font-size: 13px;
        width: 100px;
        padding-left: 20px;
        padding-right: 20px;
    }
</style>
